export default {
    'de.attribute'   : require('../../../lang/de/attribute.php'),
    'de.auth'        : require('../../../lang/de/auth.php'),
    'de.contacts'    : require('../../../lang/de/contacts.php'),
    'de.culture'     : require('../../../lang/de/culture.php'),
    'de.default'     : require('../../../lang/de/default.php'),
    'de.deficiency'  : require('../../../lang/de/deficiency.php'),
    'de.dashboard'   : require('../../../lang/de/dashboard.php'),
    'de.file'        : require('../../../lang/de/file.php'),
    'de.history'     : require('../../../lang/de/history.php'),
    'de.invoice'     : require('../../../lang/de/invoice.php'),
    'de.life_cycle'  : require('../../../lang/de/life_cycle.php'),
    'de.user'        : require('../../../lang/de/user.php'),
    'de.validation'  : require('../../../lang/de/validation.php'),
    'de.personnel'   : require('../../../lang/de/personnel.php'),
    'de.project'     : require('../../../lang/de/project.php'),
    'de.site-journal': require('../../../lang/de/site-journal.php'),
    'de.work_time'   : require('../../../lang/de/work_time.php'),
    'de.notes'       : require('../../../lang/de/notes.php'),
    'de.notification': require('../../../lang/de/notification.php'),
    'de.building'    : require('../../../lang/de/building.php'),
    'de.contract'    : require('../../../lang/de/contract.php'),
    'de.config'      : require('../../../lang/de/config.php'),

    'en.attribute'   : require('../../../lang/en/attribute.php'),
    'en.auth'        : require('../../../lang/en/auth.php'),
    'en.contacts'    : require('../../../lang/en/contacts.php'),
    'en.culture'     : require('../../../lang/en/culture.php'),
    'en.default'     : require('../../../lang/en/default.php'),
    'en.deficiency'  : require('../../../lang/en/deficiency.php'),
    'en.dashboard'   : require('../../../lang/en/dashboard.php'),
    'en.file'        : require('../../../lang/en/file.php'),
    'en.history'     : require('../../../lang/en/history.php'),
    'en.invoice'     : require('../../../lang/en/invoice.php'),
    'en.life_cycle'  : require('../../../lang/en/life_cycle.php'),
    'en.user'        : require('../../../lang/en/user.php'),
    'en.validation'  : require('../../../lang/en/validation.php'),
    'en.personnel'   : require('../../../lang/en/personnel.php'),
    'en.project'     : require('../../../lang/en/project.php'),
    'en.site-journal': require('../../../lang/en/site-journal.php'),
    'en.work_time'   : require('../../../lang/en/work_time.php'),
    'en.notes'       : require('../../../lang/en/notes.php'),
    'en.notification': require('../../../lang/en/notification.php'),
    'en.building'    : require('../../../lang/en/building.php'),
    'en.contract'    : require('../../../lang/en/contract.php'),
    'en.config'      : require('../../../lang/en/config.php'),
}
